import { useState, useEffect } from "react";

export const useAnimatedCounter = (target, duration = 2000) => {
  const [count, setCount] = useState(0);
  const stepTime = Math.abs(Math.floor(duration / target));
  const decimalPoints = String(target).split(".")[1]?.length || 0;
  const increment = Number.isInteger(target) ? 1 : 0.1;
  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prevCount) => {
        let nextCount = prevCount + increment;
        nextCount = parseFloat(nextCount.toFixed(decimalPoints));
        if (nextCount >= target) {
          clearInterval(timer);
          return target;
        }
        return nextCount;
      });
    }, stepTime);
    return () => clearInterval(timer);
  }, [target, stepTime, decimalPoints, increment]);

  return count.toFixed(decimalPoints);
};
